import { StripeCardElementOptions } from '@stripe/stripe-js'

export const FLOW = 'upgrade'

export const errorInputField = {
  border: '2px solid #a80b0b',
}

export const defaultInputField = {
  border: '1px solid #B2B2B2',
}

export const cardElementOptions: StripeCardElementOptions = {
  iconStyle: 'solid',
  style: {
    base: {
      fontFamily: "'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '1rem',
    },
    invalid: {
      iconColor: '#a80b0b',
      color: '#a80b0b',
    },
  },
}

export const THREE_D_S_CARD_TYPES = ['optional', 'recommended']
